import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Event as EventIcon } from '@mui/icons-material';

const FechaEntregaRealModal = ({ open, onClose, onConfirm, initialDate, loading = false }) => {
  const [fecha, setFecha] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      // Si hay initialDate úsala, si no la fecha de hoy
      const hoy = new Date();
      const hoyStr = hoy.toISOString().split('T')[0];
      setFecha(initialDate || hoyStr);
      setError('');
    }
  }, [open, initialDate]);

  const handleConfirm = () => {
    if (!fecha) {
      setError('Debes indicar una fecha de entrega real.');
      return;
    }
    setError('');
    onConfirm(fecha);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <EventIcon color="primary" />
          <Typography variant="h6">Confirmar Fecha de Entrega Real</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          Al cambiar la oportunidad a <strong>Entregada</strong>, se guardará la fecha de entrega real.<br />
          Puedes modificarla si lo necesitas antes de confirmar.
        </Alert>
        <TextField
          label="Fecha de Entrega Real"
          type="date"
          value={fecha}
          onChange={e => setFecha(e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
          error={!!error}
          helperText={error}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined">Cancelar</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary" disabled={loading || !fecha}>
          Guardar y Cambiar Estado
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FechaEntregaRealModal;
